var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2WhiteSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eIQ0SbwXBhM1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.42 67.29",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eIQ0SbwXBhM2",
    transform: "matrix(.75 0 0 0.75 8.302033 8.414437)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.51,13.12L11.88,15.25l.95-11.79c.143594-1.761788-1.168212-3.306406-2.93-3.45s-3.306406,1.168212-3.45,2.93l-1,11.79c-.138226,1.69215.401574,3.369883,1.500598,4.663956s2.667202,2.09843,4.359402,2.236044c.56487.04188,1.132773.011636,1.69-.09l11.64-2.13c1.157333-.171743,2.128673-.961418,2.533064-2.059317s.177356-2.328973-.592061-3.210399-1.958542-1.272668-3.101003-1.020284Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.63,23.83C-3.356145,39.155089,3.379963,55.848082,17.605929,63.420525s31.835297,3.838463,41.763792-8.855827s9.310177-30.684533-1.466456-42.667195-28.600779-14.498806-42.273265-5.967503c-1.038363.569559-1.677249,1.666038-1.660748,2.850235s.685693,2.262449,1.739524,2.802853s2.319958.454582,3.291224-.223088c11.024866-6.890844,25.405849-4.871257,34.10627,4.789699s9.208474,24.174166,1.204909,34.419865-22.208122,13.265957-33.687855,7.162913-16.920447-19.567441-12.903324-31.932477c.357266-1.087874.107019-2.283709-.656475-3.137047s-1.924241-1.234536-3.045-1-2.031259,1.049173-2.388525,2.137047Z",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2WhiteSpinner);
export default __webpack_public_path__ + "static/media/Logo2WhiteSpinner.af9c27502ee679f8ccad59ceb9bf5090.svg";
export { ForwardRef as ReactComponent };